type TypedRecord<T> = Record<string, string | boolean | T>;

// Need to disable linting here - because this works only with interfaces
// eslint-disable-next-line
interface NestedRecord extends TypedRecord<NestedRecord> {}

type BaseEnvironment = NestedRecord & {
  baseApi: string;
  api: NestedRecord & {
    navbar: string;
    manageAccessTabs: string;
  };
};

export default function baseEnv(baseApi: string): BaseEnvironment {
  return {
    baseApi: "https://api.hub.ucc-dev.vodafone.com",
    api: {
      navbar: `${baseApi}/role/nav-bar`,
      manageAccessTabs: `${baseApi}/role/permissions/ATTR-17fffb6c-fb6c-ffb6cdd30.-.432`,
      country: `${baseApi}/external-integrations/v1/solutions-hub/countries`,
      numberType: `${baseApi}/external-integrations/v1/solutions-hub/number-types`,
      serviceType: `${baseApi}/external-integrations/v1/solutions-hub/service-types`,
      users: `${baseApi}/user`,
      areas: `${baseApi}/external-integrations/v1/solutions-hub/areas`,
      customer: `${baseApi}/organisation/v1/organisation`,
    },
  };
}
export type Environment = ReturnType<typeof baseEnv> & NestedRecord;
